import { Logger } from './Logger/Logger';
import { WindowMessenger } from './WindowMessenger/WindowMessenger';

export enum ParentConnectionEvent {
  Close = 'close',
  ItemRemoved = 'itemremove',
  ItemsSubmitted = 'items',
  NotAuthorized = 'notauthorized',
  Ready = 'ready',
  SettingsReady = 'settingsReady',
  UploadProgress = 'uploadprogress',
  RouteChanged = 'routeChanged',
}

export const parentConnection = new WindowMessenger(window.parent, new Logger('Media Manager G6'));
